export default __webpack_public_path__ + "static/IOT_Support-367aeca92d0c7e8c393dd3b96e121606.png";